import React from "react";
import { Grid2 as Grid, Stack } from "@mui/material";
import { DataGrid } from "@shared/components/DataGrid";
import { useDefaultPlanList } from "@pages/dafaultPlans/list/controller";
import { useDefaultPlanListColumns } from "@pages/dafaultPlans/list/columns";
import { CsvExportButton, FilterDropdown } from "@shared/components";
import { CreateButton } from "@refinedev/mui";
import { useTranslate } from "@refinedev/core";
import { useParams } from "react-router";
import { CreateProductPlanModal } from "./CreateProductPlanModal";
import { EditProductPlanModal } from "./EditProductPlanModal";
import { DefaultPlanListFilters } from "@modules/defaultPlans/components";

export function ProductPlans() {
  const translate = useTranslate();
  const { id } = useParams();
  const {
    rows,
    loading,
    createDefaultPlanModalRef,
    editDefaultPlanModalRef,
    refetch,
    tableProps,
    selectedRows,
    setSelectedRows,
    dataToExport,
  } = useDefaultPlanList({ productId: id });

  const columns = useDefaultPlanListColumns(refetch, translate, editDefaultPlanModalRef);

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12 }}>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <FilterDropdown initialValues={{ search: "", default_product: id }}>
            <DefaultPlanListFilters />
          </FilterDropdown>
          <CsvExportButton data={dataToExport} filename="default-plans.csv" isDisabled={loading || !rows} />
          <CreateButton onClick={() => createDefaultPlanModalRef.current?.open()} />
        </Stack>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <DataGrid
          {...tableProps}
          rows={rows}
          columns={columns}
          loading={loading}
          checkboxSelection
          rowSelectionModel={selectedRows}
          onRowSelectionModelChange={(selectionModel) =>
            setSelectedRows(selectionModel as number[])
          }
        />
      </Grid>

      <CreateProductPlanModal
        onSave={() => {
          refetch();
        }}
        modalRef={createDefaultPlanModalRef}
      />
      <EditProductPlanModal
        onSave={() => {
          refetch();
        }}
        modalRef={editDefaultPlanModalRef}
      />
    </Grid>
  );
}


